import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import {DataGrid, GridToolbar} from "@mui/x-data-grid";
import Skeleton from "@mui/material/Skeleton";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,

};

export default function BasicModalTable({rows,columns, open, setOpen, loading, setLoading}) {
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const LoadingSkeleton = () => (
        <Box
            sx={{
                height: "max-content"
            }}
        >
            {[...Array(20)].map((item, key) => (
                <Skeleton key={key} variant="rectangular" sx={{my: 2, mx: 1}}/>
            ))}
        </Box>
    );

    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <div style={{ minHeight: 100, width: '100%', maxHeight: 600, overflow: "scroll" }}>
                    <DataGrid
                        rows={loading ? []:rows}
                        columns={columns}
                        autoHeight={true}
                        hideFooter={true}
                        components={{
                            LoadingOverlay: LoadingSkeleton,
                        }}
                        componentsProps={{
                            toolbar: {
                                showQuickFilter: true,
                                quickFilterProps: {debounceMs: 500},
                            },
                        }}
                        loading={loading}
                    />
                    </div>
                </Box>
            </Modal>
        </div>
    );
}